/**
 * Wallet-socket authentication for the chat relay: merely connecting to
 * /ws/chat/:room without a guest token is NOT proof of room ownership, so
 * moderation signals (mute-all, kick) are only relayed from sockets that
 * completed this EIP-191 handshake. The signed proof works like a session
 * token — it is cached and reused across reconnects within its validity
 * window. Must stay byte-identical to buildWalletSocketAuthMessage in
 * upload-orchestrator/src/websocket/chatHandler.js.
 */
export function buildWalletSocketAuthMessage(room, timestamp) {
    return `Dwinity wallet socket auth\nroom: ${room.toLowerCase()}\nts: ${timestamp}`;
}
// Server accepts up to 12h; refresh a bit earlier to avoid edge rejections.
const REUSE_WINDOW_MS = 11 * 60 * 60 * 1000;
const cache = new Map();
/**
 * Returns a cached signed proof for the room, or signs a fresh one.
 * Signing is silent for wallet devices (personal_sign via the wallet
 * provider), and reuse keeps mobile WalletConnect prompts to one per ~11h.
 */
export async function getWalletSocketAuth(room, signMessage) {
    const key = room.toLowerCase();
    const cached = cache.get(key);
    if (cached && Date.now() - cached.timestamp < REUSE_WINDOW_MS) {
        return cached;
    }
    const timestamp = Date.now();
    const signature = await signMessage(buildWalletSocketAuthMessage(key, timestamp));
    const auth = { timestamp, signature };
    cache.set(key, auth);
    return auth;
}
/** Drops the cached proof for a room — used when the relay rejects it
 *  (`wallet_auth_failed`), so the next attempt signs a fresh message. */
export function clearWalletSocketAuth(room) {
    cache.delete(room.toLowerCase());
}
